import { useMediaQuery } from '@mui/material';

export const useCustomMediaQuery = (query) => {
    return useMediaQuery(query);
};
